import React, { useState, useEffect } from "react";
import {
    SearchOutlined,
    CheckOutlined,
    CloseOutlined,
    WarningOutlined,
    CloudUploadOutlined,
    RedoOutlined
} from "@ant-design/icons";
import {
    Layout,
    Button,
    theme,
    ConfigProvider,
    Input,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Breadcrumb,
    Form,
    DatePicker,
    Upload,
    Table,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import ContentTop from "../../../components/ContentTop";
import CustomButton from "../../../components/custom/CustomButton";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import tableData from "../../../config/data/loanProducts.json"

const { Content } = Layout;
const { Text, Title } = Typography;
const Search = Input;

const columns = [
    {
        title: " Name",
        dataIndex: "Name",
    },
    {
        title: " Import Time",
        dataIndex: "importTime",
    },
    {
        title: "End Time",
        dataIndex: "endTime",
    },
    {
        title: "Completed ",
        dataIndex: "completed",
    },
    {
        title: "Total Records",
        dataIndex: "totalRecords",
    },
    {
        title: "Success Count ",
        dataIndex: "successCount",
    },
    {
        title: "Failure Count ",
        dataIndex: "failureCount",
    },
    {
        title: "Download  ",
        dataIndex: "download",
    },
];

const ImportSYA0200 = () => {
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKey, setSelectedKey] = useState("/sya0200");
    const [switchLabel, setSwitchLabel] = useState("Dark Mode");
    const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
    const [menuBG, setMenuBG] = useState("#2F172D");
    const [searchColorBgContainer, setSearchColorBgContainer] =
        useState("#3B2639");
    const [menuTheme, setMenuTheme] = useState("dark");
    const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
    const [logoDimensions, setLogoDimensions] = useState(100);
    const [menuSearchBarState, setMenuSearchBarState] = useState(false);
    const [menuSearchIconState, setMenuSearchIconState] = useState(true);
    const [switchLabelState, setSwitchLabelState] = useState(false);

    function onSwitchClick() {
        if (switchLabel === "Dark Mode") {
            setSwitchLabel("Light Mode");
            setMenuBG("#fff");
            setSearchColorBgContainer("#f7f8fa");
            setSwitchLabelColor("#8c8f9f");
            setMenuTheme("light");
        } else {
            setSwitchLabelColor("#aeaeae");
            setSwitchLabel("Dark Mode");
            setMenuBG("#2F172D");
            setSearchColorBgContainer("#3B2639");
            setMenuTheme("dark");
        }
    }

    function onMenuSelect(menuItems) {
        // console.log(menuItems.key);
        setSelectedKey(menuItems.key);
        navigate(menuItems.key, { replace: false });
    }

    useEffect(() => {
        if (collapsed === true) {
            setLeftLayoutMargin(71);
            setLogoDimensions(50);
            setMenuSearchBarState(true);
            setMenuSearchIconState(false);
            setSwitchLabelState(true);
        } else {
            setLeftLayoutMargin(190);
            setLogoDimensions(100);
            setMenuSearchBarState(false);
            setMenuSearchIconState(true);
            setSwitchLabelState(false);
        }
    });

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    return (
        <ConfigProvider
            theme={{
                components: {
                    Layout: {
                        siderBg: menuBG,
                    },
                    Menu: {
                        darkItemBg: menuBG,
                        darkSubMenuItemBg: "#241223",
                    },
                },
            }}
        >
            <MainLayout
                collapsed={collapsed}
                searchColorBgContainer={searchColorBgContainer}
                theme={menuTheme}
                defaultSelectedKeys={selectedKey}
                items={menuItems}
                onClick={onMenuSelect}
                switchLabel={switchLabel}
                onSwitchClick={onSwitchClick}
                switchLabelColor={switchLabelColor}
                logoDimensions={logoDimensions}
                menuSearchBarState={menuSearchBarState}
                menuSearchIconState={menuSearchIconState}
                switchLabelState={switchLabelState}
                setCollapsed={setCollapsed}
                leftLayoutMargin={leftLayoutMargin}
                colorBgContainer={colorBgContainer}
            >
                <MainPage titleOfPage={"Import Branch"} />
            </MainLayout>
        </ConfigProvider>
    );
};

const iconMap = {
    Authorised: <CheckOutlined />,
    Unauthorised: <CloseOutlined />,
    Disabled: <WarningOutlined />,
};

function MainPage(props) {
    const [fieldContent, setFieldContent] = useState(<ImportSYA0200Form />);
    const navigate = useNavigate();

    function CustType(value) {
        console.log(value);
        if (value === "individual") {
            setFieldContent(<ImportSYA0200Form />);
        } else if (value === "company") {
            setFieldContent(<ImportSYA0200Form />);
        }
    }

    return (
        <div style={{ marginBottom: 50 }}>
            <ContentTop titleOfPage={"Import Branch"}>
                <BreadcrumbItem>
                    <a href="/dashboard">Home</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <a href="/sya0200">Manage Branch</a>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Text>Import Branch</Text>
                </BreadcrumbItem>
            </ContentTop>

            <div>
                {fieldContent}
            </div>
            <Row gutter={16}></Row>
        </div>
    );
}

function ImportSYA0200Form() {
    const navigate = useNavigate();

    function onCancel() {
        navigate("/sya0200", { replace: false });
    }

    const onSubmit = (values) => {
        console.log("Success:", values);
    };

    return (
        <Form layout="vertical" style={{ paddingTop: 20 }} onFinish={onSubmit}>

            <Card
                style={{
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                }}
            >
              
                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    title={"User Template"}
                >
                    <Row style={{ justifyContent: "space-between" }}>

                        <Col span={8}>
                            <Form.Item
                                name="branch"
                                label={<Text strong>Branch</Text>}

                            >
                                <Button
                                    icon={<CloudUploadOutlined />}
                                    content="Download"
                                    style={{
                                        width: "30%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        backgroundColor: "#15CCAE",
                                        color: "white",
                                        hoverBackground: "#4FECA0"
                                    }}
                                    htmlType="submit"
                                >Download</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    title={"Users"}
                >
                    <Row style={{ justifyContent: "space-between" }}>

                        <Col span={8}>
                            <Form.Item
                                name="selectExcelFile"
                                label={<Text strong>Select Excel File</Text>}

                            >
                                <Upload                                >
                                    <Button
                                        style={{
                                            width: "100%",
                                            marginLeft: "auto",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                            backgroundColor: "#fff",
                                            color: "black",
                                            hoverBackground: "#F5F5F5"
                                        }}>Choose File</Button>
                                </Upload>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    content="Upload"
                                    style={{
                                        width: "25%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        backgroundColor: "#15CCAE",
                                        color: "white",
                                        hoverBackground: "#4FECA0"
                                    }}
                                    htmlType="submit">Upload</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                <Card
                    style={{
                        marginBottom: "2%",
                        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                    }}
                    title={"Documents"}
                >
                    <Row style={{ marginBottom: 20 }}>
                        <div style={{ marginBottom: "auto" }}>
                            <Button
                                icon={<RedoOutlined />}
                                style={{
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    backgroundColor: "#15CCAE",
                                    color: "white",
                                    hoverBackground: "#4FECA0"
                                }}>Refresh</Button>
                        </div>
                    </Row>
                    <Table
                        columns={columns}
                        dataSource={""}
                        bordered
                        pagination={false}
                    />
                </Card>

                <Form.Item>
                    <Row>
                        <CustomButton
                            content="Submit"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            htmlType="submit"
                            backgroundColor="#15CCAE"
                            colorText="black"
                            hoverBackground="#4FECA0"
                        />
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "1%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={onCancel}
                        />
                    </Row>
                </Form.Item>
            </Card>
        </Form>
    );
}

export default ImportSYA0200;
